const search = {
  title: 'Query the result of the $count bar related to "$keyword"',
  breadcrumbTitle: 'Query list',
  searchLoadingText: 'Searching, please wait...',
  searchResultNone: 'Sorry, no query results are available at this time(づ◡﹏◡)づ',
  tabNav: [
    { label: 'Article', value: '1', path: '/search/article' },
    { label: 'Product', value: '2', path: '/search/product' },
  ]
}


export default search


// WEBPACK FOOTER //
// ./src/config/lang/en/search.js